export var TEXTO_VACIO = '<p><br></p>';
export var TIPO_TEXTO = 'texto';
export var TIPO_NOTA = 'nota';
export var TIPO_VINCULO = 'vinculo';